export const generateImportPrompt = () => `Sei un esperto di didattica e sintesi accademica.
Analizza le immagini delle pagine del libro/manuale fornite (possono essere una o più pagine consecutive).
Estrai i concetti chiave dall'intero testo e costruisci un'unica mappa concettuale gerarchica coerente.

RISPOSTA: Restituisci ESCLUSIVAMENTE JSON valido, senza testo aggiuntivo:
{
  "mapName": "Titolo sintetico (2-4 parole)",
  "ops": [
    {"action": "add", "type": "problem", "title": "Concetto centrale", "summary": "Tema principale della pagina", "tempId": "root"},
    {"action": "add", "type": "solution", "title": "Categoria o concetto chiave", "summary": "Spiegazione breve", "parentId": "root", "tempId": "c1"},
    {"action": "add", "type": "solution", "title": "Sotto-concetto o dettaglio", "summary": "...", "parentId": "c1"}
  ]
}

REGOLE:
- Primo nodo obbligatorio: type "problem" con tempId "root" = il tema centrale del testo
- Nodi successivi: type "solution" = concetti, definizioni, esempi, formule, teorie
- Struttura gerarchica: usa parentId per collegare i nodi tra loro (max 2 livelli di profondità)
- Numero nodi: tra 6 e 12 nodi totali
- Titoli: concisi (2-5 parole), fedeli al testo originale
- Summary: una frase chiara e informativa
- Usa tempId progressivi (c1, c2, c3...) per poter creare la gerarchia
- Se il testo è poco leggibile, estrai quello che riesci e indica nell'ultimo summary "Testo parzialmente leggibile"
- Se non riesci a leggere nulla, restituisci: {"mapName": "Pagina illeggibile", "ops": [{"action": "add", "type": "problem", "title": "Pagina illeggibile", "summary": "Foto non sufficientemente nitida per l'estrazione", "tempId": "root"}]}`;
